import { Grid, Typography } from "@material-ui/core";

import { Fragment } from "react";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocTableSelection from "../../../utils/MeditocTableSelection";
import ResumenAgregarFolios from "./ResumenAgregarFolios";
import RowTotales from "./RowTotales";
import { getAgregarFolioColumns } from "../../../../models/EmpresaModel";
import { useEmpresa } from "../../../../context/EmpresaContext";

export default function AgregarFolios() {
    const {
        listaProductosSeleccionar,
        listaProductosSeleccionados,
        triggerListaProductosSeleccionar,
        empresaSeleccionada,
        subtotal,
        montoIva,
        modalOpenAgregarFolios,
        handleOpenAgregarFolios,
        handleChangeListaProductosSeleccionar,
        handleChangeListaProductosSeleccionados,
        handleSubmitAgregarFolios,
    } = useEmpresa();

    return (
        <Fragment>
            <MeditocModal
                size="large"
                okmessage="Siguiente"
                open={modalOpenAgregarFolios}
                setopen={handleOpenAgregarFolios}
                okfunc={handleSubmitAgregarFolios}
                okDisabled={listaProductosSeleccionados.length < 1}
                title={`Crear folios para ${empresaSeleccionada.sNombre} (${empresaSeleccionada.sFolioEmpresa})`}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="body1" align="center">
                            Seleccione los productos disponibles de la tabla e ingrese la cantidad acordada para generar
                            los nuevos folios
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocTableSelection
                            id="iIdProducto"
                            data={listaProductosSeleccionar}
                            rows={listaProductosSeleccionados}
                            columns={getAgregarFolioColumns()}
                            trigger={triggerListaProductosSeleccionar}
                            setData={handleChangeListaProductosSeleccionar}
                            setRows={handleChangeListaProductosSeleccionados}
                            addRows={
                                <Fragment>
                                    <RowTotales
                                        label="Subtotal"
                                        value={"$" + subtotal.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                        colSpan={5}
                                    />
                                    <RowTotales
                                        label="IVA"
                                        value={"$" + montoIva.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                        colSpan={5}
                                    />
                                    <RowTotales
                                        label="Total"
                                        value={
                                            "$" +
                                            (subtotal + montoIva).toLocaleString("en-US", { minimumFractionDigits: 2 })
                                        }
                                        colSpan={5}
                                    />
                                </Fragment>
                            }
                        />
                    </Grid>
                </Grid>
            </MeditocModal>
            <ResumenAgregarFolios />
        </Fragment>
    );
}
